export const newrentalapplication = [
  {
    key: '1',
    name: 'John Brown',
    chinese: 98,
    math: 60,
    english: 70,
  },
];

export const unit = [
  {
    value: 'test1 - 912 n creek dr  edmond, OK 73034 - $0.00',
    label: 'test1 - 912 n creek dr  edmond, OK 73034 - $0.00',
  },
  {
    value: 'Vicky - 912 n creek dr  edmond, OK 73034 - $0.00 2',
    label: 'Vicky - 912 n creek dr  edmond, OK 73034 - $0.00 2',
  },
  {
    value: 'John - 912 n creek dr  edmond, OK 73034 - $0.00 3',
    label: 'John - 912 n creek dr  edmond, OK 73034 - $0.00 3',
  },
]
export const salutation = [
  {
    value: 'Dr.',
    label: 'Dr.',
  },
  {
    value: 'Mr.',
    label: 'Mr.',
  },
  {
    value: 'Mr. & Mrs.',
    label: 'Mr. & Mrs.',
  },
  {
    value: 'Mrs.',
    label: 'Mrs.',
  },
  {
    value: 'Ms..',
    label: 'Ms..',
  },
]
export const country = [
{
  value: 'United States',
  label: 'United States',
},
{
  value: 'Canada',
  label: 'Canada',
},
{
  value: 'Afghanistan',
  label: 'Afghanistan',
},
]
export const applicanttype = [
{
  value: 'Financially Responsible',
  label: 'Financially Responsible',
},
{
  value: 'Co-signer',
  label: 'Co-signer',
},
]
export const phonenumbers = [
  {
    value: 'Fax',
    label: 'Fax',
  },
  {
    value: 'Home',
    label: 'Home',
  },
  {
    value: 'Mobile',
    label: 'Mbbile',
  },
  {
    value: 'Office',
    label: 'Office',
  },
]
export const currentaddress = [
  {
    value: 'CO',
    label: 'Co',
  },
  {
    value: 'AF',
    label: 'AF',
  },
  {
    value: 'TH',
    label: 'TH',
  },
  {
    value: 'WE',
    label: 'WE',
  },
]
export const rentalmonth = [
  {
    value: 'January',
    label: 'January',
  },
  {
    value: 'February',
    label: 'February',
  },
  {
    value: 'March',
    label: 'March',
  },
  {
    value: 'April',
    label: 'April',
  },
  {
    value: 'May',
    label: 'May',
  },
  {
    value: 'June',
    label: 'June',
  },
  {
    value: 'July',
    label: 'July',
  },
  {
    value: 'August',
    label: 'August',
  },
  {
    value: 'September',
    label: 'September',
  },
  {
    value: 'October',
    label: 'October',
  },
  {
    value: 'November',
    label: 'November',
  },
  {
    value: 'December',
    label: 'December',
  },
]
export const rentalyear = [
  {
    value: '2014',
    label: '2014',
  },
  {
    value: '2015',
    label: '2015',
  },
  {
    value: '2016',
    label: '2016',
  },
  {
    value: '2017',
    label: '2017',
  },
  {
    value: '2018',
    label: '2018',
  },
  {
    value: '2019',
    label: '2019',
  },
  {
    value: '2020',
    label: '2020',
  },
  {
    value: '2021',
    label: '2021',
  },
  {
    value: '2022',
    label: '2022',
  },
  {
    value: '2023',
    label: '2023',
  },
  {
    value: '2024',
    label: '2024',
  },
]
export const yearsworked = [
  {
    value: '01',
    label: '01',
  },
  {
    value: '02',
    label: '02',
  },
  {
    value: '03',
    label: '03',
  },
  {
    value: '04',
    label: '04',
  },
  {
    value: '05',
    label: '05',
  },
  {
    value: '06',
    label: '06',
  },
]